/**
 * Normalized environment label for audience.environments matching in notices.json.
 * Operators typically use: prod | stage | preprod | qa | dev
 */
export function getNoticeEnvironment() {
	const explicit = process.env.REACT_APP_SYSTEM_NOTICES_ENV;
	if (explicit && String(explicit).trim()) {
		return String(explicit).trim().toLowerCase();
	}
	const mode = process.env.NODE_ENV;
	if (mode === "production") return "prod";
	return "dev";
}



// WEBPACK FOOTER //
// ./src/system-notices/environment.js